import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

//for pagination kauhsalya(2017-08-04)
import {NgxPaginationModule} from 'ngx-pagination';

import {TranslateModule} from 'ng2-translate';
import { DragulaModule } from 'ng2-dragula';

import { DashboardComponent } from './dashboard.component';
import { MainBoardComponent } from './components/main-board/main-board.component';
import { TimeSheetModule } from '../work//modal/time-sheet/time-sheet.module';
import { ModalTaskModule } from '../work//modal/modal-task/modal-task.module';

import { MaindashboardComponent } from './components/maindashboard/maindashboard.component'; // kaushalya
import { MyChartComponent } from './components/maindashboard/my-chart/my-chart.component';

import { PipeCapitalizeModule } from '../../shared/modules/pipe-capitalize/pipe-capitalize.module';

import { ModalLoginAgainModule } from '../../shared/modules/modal-login-again/modal-login-again.module';

import { mainRouting } from '../main.routes';
import { AttendanceComponent } from './components/attendance/attendance.component';
import { ChartsModule } from 'ng2-charts';
import { ViewTimeComponentModule } from '../../shared/modules/view-time-component/view-time-component.module';
import { ReleaseComponent } from './components/maindashboard/release/release.component';
import { InterviewComponent } from './components/maindashboard/interview/interview.component';
import { QuickLinkComponent } from './components/maindashboard/quick-link/quick-link.component';
import { AvailableEmployeesComponent } from './components/maindashboard/available-employees/available-employees.component';
import { AvailableCvComponent } from './components/maindashboard/available-cv/available-cv.component';
import { TechTalksPresentationComponent } from './components/maindashboard/tech-talks-presentation/tech-talks-presentation.component';
import { CrowdGeneralComponent } from './components/maindashboard/crowd-general/crowd-general.component';
import { CodeStandardComponent } from './components/maindashboard/code-standard/code-standard.component';
import { BrochuresComponent } from './components/maindashboard/brochures/brochures.component';
import { PendingLeaveComponent } from './components/maindashboard/pending-leave/pending-leave.component';
import { PendingPuchinComponent } from './components/maindashboard/pending-puchin/pending-puchin.component';
import { QuickAccessComponent } from './components/maindashboard/quick-access/quick-access.component';


@NgModule({
  declarations: [
    DashboardComponent,
    MainBoardComponent,
    AttendanceComponent,
    MaindashboardComponent,
    MyChartComponent,
    ReleaseComponent,
    InterviewComponent,
    QuickLinkComponent,
    AvailableEmployeesComponent,
    AvailableCvComponent,
    TechTalksPresentationComponent,
    CrowdGeneralComponent,
    CodeStandardComponent,
    BrochuresComponent,
    PendingLeaveComponent,
    PendingPuchinComponent,
    QuickAccessComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,

    TimeSheetModule,
    ModalTaskModule,
    
    mainRouting,

    TranslateModule,
    DragulaModule,

    PipeCapitalizeModule,
    ModalLoginAgainModule,
    ViewTimeComponentModule,

    ChartsModule,
    NgxPaginationModule
    
  ]
})
export class DashboardModule { }



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/dashboard.module.ts